import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// primeReact
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
// components
import Input from "../../../../../components/input/Input";
import Panel from "../../../../../components/panel/panel";
import Select from "../../../../../components/input/Select";
import Toggle from "../../../../../components/button/Toggle";
import ExportTable from "../../../../../components/button/ExportButton";
//services
import { getSales } from "../../../../../services/Contracts/getSales";
import { getBlocks } from "../../../../../services/GlobalRoles/getBlocks";
//hooks
import { useOptionsSelect } from "../../../../../hooks/useOptionsSelect";
//utils
import { formatDate, formatIsoDate } from "../../../../../utils/formatDate";
import { useAppContext } from "../../../../../context/AppContext";
import { useFiltersContext } from "../../../../../context/FiltersContext";

const Contracts = ({
  id,
  name,
  selectedCustomers,
  setSelectedCustomers,
  setSelectAll,
  selectAll,
}) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { nomenclatures: getComenclatures, permissions } = useAppContext();
  const [table, setTable] = useState(null);
  const [tableToExport, setTableToExport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const { id: enterpriseId } = useParams();

  const { data: blocks, isLoading: isLoadingBlocks } = useQuery("blocks", () =>
    getBlocks(id)
  );

  const {
    selectBlock,
    lands,
    isLoadingLands,
    team,
    isLoadingTeams,
    selectTeam,
    members,
    brokers,
    imobs,
    loadingMembers,
    isLoadingImobs,
    isLoadingBroker,
    setLands,
  } = useOptionsSelect();

  const nomenclatures = JSON.parse(getComenclatures);
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const columns = [
    { field: "id", header: "Nº Ficha" },
    { field: "broker", header: "Imobiliária / Corretor" },
    { field: "name_cli", header: "Cliente" },
    // { field: "bank", header: "Banco" }, 
    {
      field: "created_at",
      header: "Data Venda",
      body: (rowData) => formatDate(rowData.created_at),
    },
    { field: "block", header: nomenclatures[0].value },
    { field: "land", header: nomenclatures[1].value },
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        if (rowData.isCessionsPending) {
          labelClass = "badge bg-warning";
          labelText = "Pendente de Cessão";
        } else if (rowData.isContractTerminationPending) {
          labelClass = "badge bg-warning";
          labelText = "Pendente de Distrato";
        } else if (rowData.isRenegotiationPending) {
          labelClass = "badge bg-warning";
          labelText = "Pendente de Renegociação";
        } else {
          switch (rowData.status) {
            case 3:
              labelClass = "badge bg-success";
              labelText = "Contrato ativo";
              break;
            case 4:
              labelClass = "badge bg-info";
              labelText = "Contrato concluído";
              break;
            case 5:
              labelClass = "badge bg-danger";
              labelText = "Contrato cancelado";
              break;
            case 6:
              labelClass = "badge bg-secondary";
              labelText = "Contrato Cobrança Extrajudicial";
              break;
            default:
          }
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
              marginRight: "-10px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
  ];

  const form = useForm({
    shouldUnregister: false,
  });
  const errors = form.formState.errors;

  const optionsStatus = [
    {
      label: "Contrato ativo",
      value: 3,
    },
    {
      label: "Contrato concluído",
      value: 4,
    },
    {
      label: "Contrato cancelado",
      value: 5,
    },
    {
      label: "Contrato Cobrança Extrajudicial",
      value: 6,
    },
    {
      label: "Pendente de Cessão",
      value: 7,
    },
    {
      label: "Pendente de Distrato",
      value: 8,
    },
    {
      label: "Pendente de Renegociação",
      value: 9,
    },
  ];

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.header,
  }));

  const onSelectionChange = (event) => {
    const value = event.value;

    setSelectedCustomers(value);
    setSelectAll(value.length === totalRecords);
  };
  const onSelectAllChange = (event) => {
    setSelectAll(event.checked);

    if (event.checked) {
      setSelectedCustomers(table);
    } else {
      setSelectedCustomers([]);
    }
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };
  const optionsSigned = [
    {
      value: 1,
      label: "Sim",
    },
    {
      value: 0,
      label: "Não",
    },
  ];
  const optionsScanned = [
    {
      value: 1,
      label: "Sim",
    },
    {
      value: 0,
      label: "Não",
    },
  ];
  const optionsSMS = [
    {
      value: 1,
      label: "SMS Ativ.",
    },
    {
      value: 0,
      label: "SMS Bloq.",
    },
  ];

  useEffect(() => {
    if (table) {
      // console.log("tabela", table);
      const dataWithoutIds = table.map((t) => ({
        "Nº Ficha": t.id,
        "Imobiliária / Corretor": `${t.real_estate} / ${t.broker}`,
        Cliente: t.name_cli,
        "Data Venda": t.created_at,
        Quadra: t.block,
        Lote: t.land,
        Status: t.status,
      }));

      // console.log("sem ids", dataWithoutIds);
      setTableToExport(dataWithoutIds);
    }
  }, [table]);

  const { setLastContractFilter, lastContractFilter } = useFiltersContext();

// const contratos = [ /* array de contratos/parcela */ ];
// contratos.forEach(contrato => {
//   console.log("Banco da parcela:", contrato.bank);
// });

  const onSubmit = async (data) => {
    const currentFormData = form.getValues();
    currentFormData.enterprise_id = id;
    currentFormData.bank = currentFormData.bank == "all" ? null : currentFormData.bank;
    // console.log("Dados do formulário:", currentFormData.bank);
    currentFormData.signature =
      currentFormData.signature == "all" ? null : currentFormData.signature;
    currentFormData.scanned =
      currentFormData.scanned == "all" ? null : currentFormData.scanned;
    currentFormData.enable_ibjuridico = currentFormData.enable_ibjuridico
      ? 1
      : 0;
    currentFormData.block_sms = currentFormData.block_sms ? 1 : 0;
    if (currentFormData.status === 7) {
      currentFormData.isCessionsPending = 1;
      currentFormData.status = undefined;
    } else {
      currentFormData.isCessionsPending = 0;
    }
    if (currentFormData.status === 8) {
      currentFormData.isContractTerminationPending = 1;
      currentFormData.status = undefined;
    } else {
      currentFormData.isContractTerminationPending = 0;
    }
    if (currentFormData.status === 9) {
      currentFormData.isRenegotiationPending = 1;
      currentFormData.status = undefined;
    } else {
      currentFormData.isRenegotiationPending = 0;
    }
    const notification = toast.loading(
      "Por favor aguarde a consulta está sendo realizada..."
    );
    const filterKey = `lastContractFilter_${enterpriseId}`;
    sessionStorage.setItem(filterKey, JSON.stringify(currentFormData));
    setLastContractFilter(currentFormData);
    const resultCacheKey = `cache_contract_${enterpriseId}_${JSON.stringify(
      currentFormData
    )}`;
    try {
      setLoading(true);
      const response = await getSales(currentFormData, "contract");
      // response.map(
      //   (item) => (item.created_at = formatDate(item.created_at))
      // );
      response.forEach(item => {
  // console.log("Banco da parcela:", item.bank);
});
      const itemToCache = { data: response, timestamp: Date.now() };
      sessionStorage.setItem(resultCacheKey, JSON.stringify(itemToCache));
      setTotalRecords(response.length);
      setTable(response);
      toast.dismiss(notification);
      toast.success("Consulta Realizada!", {
        autoClose: 1000,
        theme: "colored",
      });
      setLoading(false);
      setShowTable(true);
    } catch (e) {
      toast.dismiss(notification);
      toast.error("Houve um erro a buscar os dados, tente novamente", {
        autoClose: 5000,
        theme: "colored",
      });
      setLoading(false);
    }
  };

  const blockId = form.watch("block_id");
  useEffect(() => {
    if (blockId) {
      selectBlock(blockId);
    } else {
      form.setValue("land_id", undefined, { shouldValidate: true });
    }
  }, [blockId]);
  
  const clearExpiredCache = (prefix) => {
    for (const key in sessionStorage) {
      if (key.startsWith(prefix)) {
        try {
          const item = JSON.parse(sessionStorage.getItem(key));
          if (item && item.timestamp) {
            const twoMinutes = 2 * 60 * 1000;
            if (Date.now() - item.timestamp > twoMinutes) {
              console.log(`Limpando cache expirado: ${key}`);
              sessionStorage.removeItem(key);
            }
          }
        } catch (e) {
          sessionStorage.removeItem(key);
        }
      }
    }
  };

  const clearCacheForContracts = () => {
    const cachePrefix = `cache_contract_${enterpriseId}_`;
    for (const key in sessionStorage) {
      if (key.startsWith(cachePrefix)) {
        sessionStorage.removeItem(key);
      }
    }
    const filterKey = `lastContractFilter_${enterpriseId}`;
    sessionStorage.removeItem(filterKey);
  };
  
  useEffect(() => {
    const cachePrefix = `cache_contract_${enterpriseId}_`;
    clearExpiredCache(cachePrefix);
    const filterKey = `lastContractFilter_${enterpriseId}`;
    const savedFilterJSON = sessionStorage.getItem(filterKey);

    if (savedFilterJSON) {
      const savedFilter = JSON.parse(savedFilterJSON);

      setLastContractFilter(savedFilter);
      form.reset(savedFilter);

      const resultCacheKey = `cache_contract_${enterpriseId}_${JSON.stringify(
        savedFilter
      )}`;
      const cachedResultItem = sessionStorage.getItem(resultCacheKey);

      if (cachedResultItem) {
        const { data: cachedData, timestamp } = JSON.parse(cachedResultItem);
        const twoMinutes = 2 * 60 * 1000;
        
        if (Date.now() - timestamp < twoMinutes) {
          setTable(cachedData);
          setShowTable(true);
        } else {
          console.log("Cache do resultado expirou.");
          sessionStorage.removeItem(resultCacheKey);
        }
      }
    } else {
      console.log("Nenhum filtro salvo encontrado para este empreendimento.");
    }
  }, [enterpriseId]);

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <Panel title="Filtro de Dados">
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="row justify-content-end">
              <div className="col-xl-2 col-md-4 mb-3">
                <Input
                  name="name_cli"
                  control={form.control}
                  errors={errors}
                  label="Cliente"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-3">
                <Select
                  name="block_id"
                  label={
                    isLoadingBlocks
                      ? "Carregando..."
                      : `${nomenclatures && nomenclatures[0].value}`
                  }
                  control={form.control}
                  errors={errors}
                  options={
                    blocks &&
                    Object.keys(blocks).map((index) => {
                      const dado = blocks[index];
                      return {
                        value: dado.id,
                        label: dado.name,
                      };
                    })
                  }
                  onChange={(e) => selectBlock(e)}
                  disabled={isLoadingBlocks ? true : false}
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-3">
                <Select
                  name="land_id"
                  label={
                    isLoadingLands
                      ? "Carregando..."
                      : `${nomenclatures && nomenclatures[1].value}`
                  }
                  control={form.control}
                  errors={errors}
                  options={lands || null}
                  disabled={isLoadingLands || !form.getValues("block_id")}
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-3">
                <Select
                  name="status"
                  label="Status"
                  control={form.control}
                  errors={errors}
                  options={optionsStatus}
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-3">
                <Select
                  name="team_id"
                  label={isLoadingTeams ? "Carregando..." : `Time`}
                  control={form.control}
                  errors={errors}
                  onChange={(e) => selectTeam(e)}
                  disabled={isLoadingTeams ? true : false}
                  options={team}
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-3">
                <Select
                  name="real_estate_id"
                  label={isLoadingImobs ? "Carregando..." : `Imobiliária`}
                  control={form.control}
                  errors={errors}
                  // onChange={(e) => selectTeam(e)}
                  disabled={isLoadingImobs ? true : false}
                  options={imobs}
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-3">
                <Select
                  name="broker_id"
                  label={isLoadingBroker ? "Carregando..." : "Corretor"}
                  control={form.control}
                  options={brokers}
                  disabled={isLoadingBroker ? true : false}
                  errors={errors}
                />
              </div>
              <div className="col-xl-3 col-md-4 mb-3">
                <Input
                  name="sale_id"
                  control={form.control}
                  errors={errors}
                  label="Número Ficha"
                />
              </div>
              <div className="col-xl-2 col-md-4">
                <Select
                  options={optionsSigned}
                  name="signature"
                  label="Assinado"
                  control={form.control}
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
              <div className="col-xl-2 col-md-4">
                <Select
                  options={optionsScanned}
                  name="scanned"
                  label="Escaneado"
                  control={form.control}
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
              <div className="col-xl-3 col-md-8 my-3">
                <Toggle
                  name="enable_ibjuridico"
                  onLabel="Ação Judicial"
                  offLabel="Ação Judicial"
                  control={form.control}
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
              <div className="col-xl-2 col-md-4 my-3">
                {/* <Select
                  options={optionsSMS}
                  name="block_sms"
                  label="SMS"
                  control={form.control}
                  getFormErrorMessage={getFormErrorMessage}
                /> */}
                <Button
                  type="submit"
                  icon="fa fa-search"
                  aria-label="Search"
                  loading={loading}
                  className={`rounded-3 py-2.5 w-100`}
                />
              </div>
            </div>
            {/* <div className="d-flex justify-content-end">
              <div
                className={`${
                  window.innerWidth <= 992 ? "w-25" : "col-md-1"
                } text-center`}
              >
                <Button
                  type="submit"
                  icon="fa fa-search"
                  aria-label="Search"
                  loading={loading}
                  className={`rounded-3 py-2.5 w-100`}
                />
              </div>
            </div> */}
          </form>
        </Panel>
      </div>
      {showTable && (
        <div className="row">
          <Panel
            title={`Informações de Venda de ${nomenclatures[1].value}`}
            buttonPlanilha={
              <ExportTable
                tableData={tableToExport}
                exportColumns={exportColumns}
                tabelaKey="Relatório de Contratos"
                globalFilterValue={globalFilterValue}
                onGlobalFilterChange={(e) =>
                  setGlobalFilterValue(e.target.value)
                }
              />
            }
          >
            <>
              <hr className="my-3" />
              <div className="px-2 pb-3">
                <DataTable
                  rows={25}
                  paginator
                  stripedRows
                  showGridlines
                  sortMode="multiple"
                  selectionMode="single"
                  rowsPerPageOptions={[25, 100, 200]}
                  globalFilter={globalFilterValue}
                  selectAll={selectAll}
                  selection={selectedCustomers}
                  onSelectionChange={onSelectionChange}
                  onSelectAllChange={onSelectAllChange}
                  value={table}
                  emptyMessage={
                    <div style={{ textAlign: "center" }}>
                      Nenhuma Informação foi encontrada.
                    </div>
                  }
                  tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                >
                  <Column
                    field="id"
                    headerStyle={{ width: "3rem" }}
                    selectionMode="multiple"
                  />
                  {columns.map((col) => (
                    <Column
                      sortable
                      key={col.field}
                      field={col.field}
                      header={col.header}
                      body={col.body}
                    />
                  ))}
                  {permissions &&
                    permissions.includes("36") && ( //Visualizar Parcelas
                      <Column
                        header="Parcelas"
                        body={(rowData) => (
                          <div className="text-center">
                            <button
                              className="btn btn-info btn-btn-sm"
                              onClick={() => {
                                // console.log("rowData.bank:", rowData.bank); 
                                navigate(`/enterprise/contracts/parcel`, {
                                  state: {
                                    id: rowData.id,
                                    enterpriseId: id,
                                    enterpriseName: state
                                      ? state.name
                                      : "Empreendimento",
                                    name_cli: rowData.name_cli,
                                    block: rowData.block,
                                    land: rowData.land,
                                    type_sale: rowData.type_sale,
                                    bank: rowData.bank,
                                  },
                                  
                                })
                              }
                              }
                            >
                              <i className="fa-solid fa-file-invoice"></i>
                            </button>
                          </div>
                        )}
                      />
                    )}
                  {permissions &&
                    permissions.includes("37") && ( //Visualizar Resumo do Contrato
                      <Column
                        header="Resumo"
                        body={(rowData) => (
                          <div className="position-relative">
                            {rowData.isCessionsPending ||
                            rowData.isContractTerminationPending ||
                            rowData.isRenegotiationPending ? (
                              <Badge
                                severity="danger"
                                style={{
                                  position: "absolute",
                                  right: 4,
                                  top: "-5px",
                                  minWidth: "15px",
                                  height: "15px",
                                  lineHeight: "15px",
                                }}
                                value={
                                  [
                                    rowData.isCessionsPending,
                                    rowData.isContractTerminationPending,
                                    rowData.isRenegotiationPending,
                                  ].filter(Boolean).length
                                }
                              ></Badge>
                            ) : null}
                            <div className="text-center">
                              <button
                                className="btn btn-success btn-btn-sm"
                                onClick={() =>
                                  navigate(`/enterprise/contracts/details`, {
                                    state: {
                                      id: rowData.id,
                                      enterpriseId: id,
                                      name: name,
                                      name_cli: rowData.name_cli,
                                      block: rowData.block,
                                      land: rowData.land,
                                      index: rowData.isRenegotiationPending
                                        ? 1
                                        : rowData.isCessionsPending
                                        ? 3
                                        : rowData.isContractTerminationPending
                                        ? 4
                                        : -1,
                                    },
                                  })
                                }
                              >
                                <i className="fa-solid fa-arrow-up-right-from-square"></i>
                              </button>
                            </div>
                          </div>
                        )}
                      />
                    )}
                </DataTable>
              </div>
            </>
          </Panel>
        </div>
      )}
    </>
  );
};

export default Contracts;
